import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BlogCategory, BlogsService, BlogStatus } from '../../../../services/blog';


@Component({
  selector: 'app-createblog',
  templateUrl: './createblog.component.html',
  styleUrl: './createblog.component.scss',
})
export class CreateblogComponent implements OnInit {
  isAr = true;

  blogForm!: FormGroup;

  isSubmitting = false;
  errorMessage = '';
  successMessage = '';

  selectedImageFile: File | null = null;
  imagePreviewUrl: string | null = null;

  allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
  maxImageSize = 4 * 1024 * 1024; // 4MB

  categories: { value: Exclude<BlogCategory, 'all'>; label: string }[] = [
    { value: 'career', label: 'المسار المهني' },
    { value: 'cv', label: 'السيرة الذاتية' },
    { value: 'travel', label: 'السفر' },
    { value: 'interview', label: 'المقابلات' },
  ];

  constructor(
    private fb: FormBuilder,
    private blogsService: BlogsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isAr = localStorage.getItem('language') === 'ar' || true;
    this.createForm();
  }

  createForm(): void {
    this.blogForm = this.fb.group({
      title_en: ['', Validators.required],
      title_ar: ['', Validators.required],
      slug: [''],

      category: ['career', Validators.required],
      category_en: ['Career'],
      category_ar: ['المسار المهني'],
      icon: ['📝'],

      excerpt_en: [''],
      excerpt_ar: [''],

      content_en: [''],
      content_ar: [''],

      tags_en: [''],
      tags_ar: [''],

      read_time_en: ['5 min read'],
      read_time_ar: ['٥ دقائق قراءة'],

      published_at: [this.getTodayDate()],
      status: ['published' as BlogStatus, Validators.required],
      is_featured: [false],

      meta_title_en: [''],
      meta_title_ar: [''],
      meta_description_en: [''],
      meta_description_ar: [''],
    });
  }

  onCategoryChange(event: Event): void {
    const category = (event.target as HTMLSelectElement).value;

    const map: any = {
      career: {
        en: 'Career',
        ar: 'المسار المهني',
        icon: '💼',
      },
      cv: {
        en: 'CV',
        ar: 'السيرة الذاتية',
        icon: '📄',
      },
      travel: {
        en: 'Travel',
        ar: 'السفر',
        icon: '✈️',
      },
      interview: {
        en: 'Interview',
        ar: 'المقابلات',
        icon: '🎯',
      },
    };

    const item = map[category];

    if (!item) {
      return;
    }

    this.blogForm.patchValue({
      category_en: item.en,
      category_ar: item.ar,
      icon: item.icon,
    });
  }

  onImageSelected(event: Event): void {
    this.errorMessage = '';

    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (!file) {
      return;
    }

    if (!this.allowedImageTypes.includes(file.type)) {
      this.errorMessage = 'نوع الصورة غير مسموح. استخدم jpg أو png أو webp أو gif.';
      input.value = '';
      return;
    }

    if (file.size > this.maxImageSize) {
      this.errorMessage = 'حجم الصورة كبير. الحد الأقصى 4MB.';
      input.value = '';
      return;
    }

    this.selectedImageFile = file;
    this.imagePreviewUrl = URL.createObjectURL(file);
  }

  removeSelectedImage(): void {
    this.selectedImageFile = null;
    this.imagePreviewUrl = null;
  }

  submitBlog(): void {
    this.errorMessage = '';
    this.successMessage = '';

    if (this.blogForm.invalid) {
      this.blogForm.markAllAsTouched();
      this.errorMessage = 'من فضلك املأ الحقول المطلوبة.';
      return;
    }

    this.isSubmitting = true;

    const payload = { ...this.blogForm.value };

    if (!payload.slug) {
      delete payload.slug;
    }

    if (!payload.published_at) {
      delete payload.published_at;
    }

    const formData = this.blogsService.buildBlogFormData(payload);

    if (this.selectedImageFile) {
      formData.append('image', this.selectedImageFile);
    }

    this.blogsService.addBlog(formData).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.successMessage = 'تم إنشاء المقال بنجاح.';
        this.resetForm();

        // عدّل المسار ده حسب route صفحة كل المقالات عندك
        // this.router.navigate(['/admin/allblogs']);
      },
      error: (err) => {
        this.isSubmitting = false;

        if (err?.error?.message) {
          this.errorMessage = err.error.message;
          return;
        }

        this.errorMessage = 'حدث خطأ أثناء إنشاء المقال.';
      },
    });
  }

  resetForm(): void {
    this.blogForm.reset({
      title_en: '',
      title_ar: '',
      slug: '',

      category: 'career',
      category_en: 'Career',
      category_ar: 'المسار المهني',
      icon: '📝',

      excerpt_en: '',
      excerpt_ar: '',

      content_en: '',
      content_ar: '',

      tags_en: '',
      tags_ar: '',

      read_time_en: '5 min read',
      read_time_ar: '٥ دقائق قراءة',

      published_at: this.getTodayDate(),
      status: 'published',
      is_featured: false,

      meta_title_en: '',
      meta_title_ar: '',
      meta_description_en: '',
      meta_description_ar: '',
    });

    this.selectedImageFile = null;
    this.imagePreviewUrl = null;
  }

  goBack(): void {
    this.router.navigate(['/allblogs']);
  }

  getTodayDate(): string {
    return new Date().toISOString().slice(0, 10);
  }

  isInvalid(controlName: string): boolean {
    const control = this.blogForm.get(controlName);
    return !!control && control.invalid && (control.touched || control.dirty);
  }
}